import React, {useEffect, useState} from 'react';

// custom components
import { Text } from '../atoms';
import { TableNumber } from '../molecules';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

const IntegrationRow = (props) => {

    useEffect(() => {

    }, []);

    const [STATE, SETSTATE] = useState(false)

    return (
        <Row className='mt-4'>
            <Col>
                <Container>
                    <Text.Subheading>{props.title}</Text.Subheading>
                    <Text.Text>{props.description}</Text.Text>
                    <Text.Text>{props.description2}</Text.Text>

                    <Text.Text>{props.example1}</Text.Text>
                    <Text.Text>{props.example2}</Text.Text>

                    {props.other}

                    

                    {props.imageTitle}
                    {props.image}

                    <div className='mt-3'>
                        <Text.Text>{props.imageDescription}</Text.Text>
                    </div>

                </Container>
            </Col>
        </Row>
    );
};

export default IntegrationRow;